var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"only-header-layout"},[_c('MyAccountClinician'),_vm._v(" "),_c('ClinicianNavbar',{attrs:{"user":_vm.user,"no-sidebar":true}}),_vm._v(" "),_c('div',{staticClass:"view-container"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }